/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

import {InspectorControls} from '@wordpress/block-editor';

import {Fragment,useState} from '@wordpress/element';

import {VayuBlocksHeaderTab,usePanelSettings} from '@vayu-blocks';

import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import ProductSettingPanel from './settings/index.js';

const panelKeys = [
	'vb-product-general',
	'vb-product-overlay',
	'vb-product-element',
	'vb-product-box',
	'vb-product-tab',
	'vb-product-sale',
	'vb-product-meta',
];

const initialPanels = {
	setting: 'vb-product-general',
    advanced: '',
};

const panelOptions = [
	{ label: __( 'Setting', 'vayu-blocks' ), value: 'setting', icon: 'colorwand'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const InsSettings = (props) => {
	
const {
		attributes,
		setAttributes,
		clientId
	} = props;

const {tab, setTab, openPanels, onTogglePanel  } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });
const tabComponents = {
			setting: <ProductSettingPanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
			advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>
	};

return (
        <Fragment>
           <InspectorControls>
			<div className='th-block-ins'>
           <VayuBlocksHeaderTab 
								value={ tab }
								options={panelOptions}
								onChange={ setTab }
							/>
						
						{tabComponents[tab]}
		 </div>
        </InspectorControls>
        </Fragment>
        );
}
export default InsSettings;